import { UseFormRegisterReturn } from "react-hook-form";
import { Radio, Stack } from "@adfenix/alexandria";
import { useContext } from "react";
import { CampaignTemplateContext } from "./CampaignTemplateContext";

interface InputData {
  value: string | number;
  label?: string;
}

interface InputGroupProps {
  data: InputData[];
  register: () => UseFormRegisterReturn;
  disabled: boolean;
}

export const RadioGroup = ({ data, register, disabled }: InputGroupProps) => {
  const { campaignKey } = useContext(CampaignTemplateContext);
  return (
    <Stack spacing="m">
      {data.map(x => {
        const { value, label } = x;
        const valueAsString =
          typeof value === "string" ? value : value?.toString();

        return (
          <Radio
            key={value}
            readOnly={disabled}
            id={`${campaignKey}.${valueAsString}`}
            value={value}
            label={label ?? value.toString()}
            {...register()}
          />
        );
      })}
    </Stack>
  );
};
